var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-wrap"},[_c('Banner'),_c('div',{staticClass:"content"},[_vm._m(0),_vm._m(1),_c('div',{staticClass:"submit",on:{"click":_vm.toCase}},[_c('label',[_vm._v("好的")])])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('img',{attrs:{"src":"https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/success.png"}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ok"},[_c('span',[_vm._v("恭喜您，提交成功")])])
}]

export { render, staticRenderFns }